import { Controller } from "@hotwired/stimulus"

interface HTMLTurboFrameElement extends HTMLElement {
  reload(): void
}

export default class PollController extends Controller {
  static values = { interval: Number }

  declare readonly intervalValue: number

  private timer?: ReturnType<typeof setInterval>

  connect(): void {
    this.timer = setInterval(() => {
      (this.element.closest("turbo-frame") as HTMLTurboFrameElement | null)?.reload()
    }, this.intervalValue)
  }

  disconnect(): void {
    if (this.timer) clearInterval(this.timer)
  }
}
